import { useEffect } from "react";
import { useBranding } from "../branding/BrandingProvider";

const useDocumentTitle = (title: string): void => {
  const { appName } = useBranding();
  useEffect(() => {
    document.title = `${appName} | ${title}`;
  }, [appName, title]);
};

export default useDocumentTitle;
